import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { checkmarkIcon } from '../../icons';
import { removeStringDuplicates } from '../core/helpers';
import { listAnimation } from './used-car.animations';

@Component({
    selector: 'app-used-car-selected-equipment',
    template: `
        <section class="used-car-selected-equipment" [ngClass]="{ 'motorpoint': isMotorpoint }">

            <ng-container *ngIf="isMotorpoint">
                <h3 class="used-car-details__header">{{ 'used_car_details.equipment' | translate }}</h3>
                <h2 class="used-car-details-primary-heading">{{ 'used_car_details.the_car_equipment' | translate }}</h2>
                <hr class="used-car-details-break used-car-equipment__break" />
            </ng-container>

            <div class="used-car-selected-equipment-list" [ngClass]="{ 'motorpoint': isMotorpoint }">

                <h6 class="used-car-selected-equipment-list__heading" *ngIf="isMotorpoint">{{ 'used_car_details.equipment_list' | translate }}</h6>

                <ul [@listAnimation]="viewList.length" *ngIf="viewList.length" class="used-car-selected-equipment-list__container">
                    <li class="used-car-selected-equipment-list__item" *ngFor="let equipment of viewList">
                        <span class="icon">${checkmarkIcon}</span>
                        <span>{{ equipment }}</span>
                    </li>
                </ul>
                <button
                    *ngIf="equipment && equipment.length > viewListCollapsedAmount"
                    class="button--as-link used-car-selected-equipment-list__button"
                    type="button"
                    (click)="onToggleSizeClick()"
                >
                    {{
                        (isExpanded ? 'used_car_details.partial_list_of_equipment_button' : 'used_car_details.complete_list_of_equipment_button')
                            | translate
                    }}
                </button>
            </div>
        </section>
    `,
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [listAnimation],
})
export class UsedCarSelectedEquipmentComponent implements OnInit {
    @Input() equipment?: string[] | null;
    @Input() isMotorpoint?: boolean;

    isExpanded = false;
    viewList: string[] = [];
    viewListCollapsedAmount = 8;

    ngOnInit() {
        this.setViewList();
    }

    onToggleSizeClick() {
        this.isExpanded = !this.isExpanded;
        this.setViewList();
    }

    private setViewList() {
        if (!this.equipment) {
            return false;
        }

        // Remove duplicate data
        const updatedList = removeStringDuplicates(this.equipment);

        if (this.isExpanded) {
            this.viewList = [...updatedList];
        } else {
            this.viewList = [...updatedList.slice(0, this.viewListCollapsedAmount)];
        }
    }
}
